"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.rSelectTextarea = exports.rNoContent = exports.rInput = exports.rCRLF = exports.baseConfig = exports.SUPPORTED_PREPARED_DATA_TYPES = exports.SUPPORTED_METHODS = exports.CONTENT_TYPE_JSON = exports.CONTENT_TYPE_FORM_URLENCODED = void 0;
/**
 * Base config for global
 *
 * @type {object} baseConfig
 * @type {string} baseConfig.baseURL The base path in which to start requests, offering relative paths for individual requests
 */
const baseConfig = exports.baseConfig = {
  baseURL: '',
  serializeArray: true
};
const CONTENT_TYPE_FORM_URLENCODED = exports.CONTENT_TYPE_FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=utf-8';
const CONTENT_TYPE_JSON = exports.CONTENT_TYPE_JSON = 'application/json;charset=utf-8';

/**
 * Regular Expression to check for whole instance of 'get' or 'head' with case-insensitivity
 */
const rNoContent = exports.rNoContent = /^(get|head)$/i;

/**
 * Regular Expression to check for line feed with optional carriage return
 */
const rCRLF = exports.rCRLF = /\r?\n/g;

/**
 * Regular Expression to check input types for valid type
 */
const rInput = exports.rInput = /^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i;

/**
 * Regular Expression to check nodeName for select or textarea
 */
const rSelectTextarea = exports.rSelectTextarea = /^(?:select|textarea)/i;

/**
 * List of HTTP methods that are supported through this Ajax implementation
 *
 * @type {array}
 */
const SUPPORTED_METHODS = exports.SUPPORTED_METHODS = ['delete', 'get', 'head', 'options', 'patch', 'post', 'put'];

/**
 * List of dataTypes that are supported for use in data preparation task
 *
 * @type {Object}
 */
const SUPPORTED_PREPARED_DATA_TYPES = exports.SUPPORTED_PREPARED_DATA_TYPES = {
  FORM_DATA: 'FORM_DATA',
  JSON: 'JSON',
  URL_SEARCH_PARAMS: 'URL_SEARCH_PARAMS'
};